'use client';
import Button from '@/components/atoms/button';
import Input from '@/components/atoms/Input';
import Modal from '@/components/molecules/modal';
import React, { useState } from 'react';
import { RiDiscountPercentFill } from 'react-icons/ri';
interface PopupProps {
    open: boolean;
    loading?: boolean;
    onCheckVoucher: () => void;
    onClose: () => void;
    onCancelVoucher: () => void;
    test?: any;
    voucherValue: string;
    setVoucherValue: (value: string) => void;
    voucherError: string;
    setVoucherError: (value: string) => void;
}

const ModalVoucher: React.FC<PopupProps> = ({
    open,
    loading,
    onCheckVoucher,
    onClose,
    onCancelVoucher,
    test,
    voucherValue,
    setVoucherValue,
    voucherError,
    setVoucherError
}) => {
    const handleValidateForm = () => {
        if (!voucherValue.trim()) {
            setVoucherError(!voucherValue.trim() ? 'Vui lòng nhập mã voucher' : '');
            return false;
        }
        return true;
    };

    return (
        <Modal
            open={open}
            centered
            onCancel={onClose}
            footer={false}
            className="p-modal-voucher"
            width={'600px'}
        >
            <div className="p-modal-voucher">
                <div className="p-modal-voucher_title">
                    <RiDiscountPercentFill /> <p>Nhập mã voucher!</p>
                </div>
                {test && <p>{test}</p>}
                <div className="p-modal-voucher_desc">
                    Nhập mã voucher của bạn để tận hưởng ưu đãi đặc biệt.
                </div>
                <div className="p-modal-voucher_input">
                    <Input
                        placeholder="NHẬP VOUCHER"
                        id="voucher"
                        errorMessage={voucherError}
                        value={voucherValue}
                        onChange={(e) => {
                            setVoucherValue(e.target.value);
                            setVoucherError('');
                        }}
                    />
                    <Button
                        shape="fill"
                        variant="secondary"
                        onClick={() => {
                            if (!handleValidateForm()) return;
                            onCheckVoucher();
                        }}
                        loading={loading}
                        className="p-modal-voucher_btn"
                    >
                        Nhận ưu đãi
                    </Button>
                </div>
                <div className="p-modal-voucher_cancel" onClick={onCancelVoucher}>
                    Tiếp tục không dùng mã
                </div>
            </div>
        </Modal>
    );
};

export default ModalVoucher;